/**
 * shop-header.js v2 — FlorixSports Shop Header
 * Matches ShopNavbar.jsx behaviour
 * ─────────────────────────────────────────────
 * 1. Scroll → backdrop blur + shadow
 * 2. Dropdown hover is CSS-native (no JS needed)
 *    JS adds keyboard + click fallback for accessibility
 * 3. Mobile hamburger toggle
 * 4. Close mobile menu when a link is tapped
 */

(function () {
  'use strict';

  var header       = document.getElementById('shopHeader');
  if (!header) return;

  var hamburger    = header.querySelector('.shop-nav__hamburger');
  var mobileMenu   = header.querySelector('.shop-mobile-menu');

  /* ── 1. Scroll: add .is-scrolled class ── */
  function onScroll() {
    header.classList.toggle('is-scrolled', window.scrollY > 10);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll(); /* run once on load */

  /* ── 2. Mobile menu toggle ── */
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function () {
      var open = mobileMenu.classList.contains('is-open');
      if (open) {
        mobileMenu.classList.remove('is-open');
        hamburger.classList.remove('is-open');
        hamburger.setAttribute('aria-expanded', 'false');
        mobileMenu.setAttribute('aria-hidden', 'true');
        hamburger.setAttribute('aria-label', 'Open menu');
      } else {
        mobileMenu.classList.add('is-open');
        hamburger.classList.add('is-open');
        hamburger.setAttribute('aria-expanded', 'true');
        mobileMenu.setAttribute('aria-hidden', 'false');
        hamburger.setAttribute('aria-label', 'Close menu');
      }
    });

    /* Close menu when any link inside is followed */
    mobileMenu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        mobileMenu.classList.remove('is-open');
        hamburger.classList.remove('is-open');
        hamburger.setAttribute('aria-expanded', 'false');
        hamburger.setAttribute('aria-label', 'Open menu');
      });
    });
  }

  /* ── 3. ESC key closes dropdowns + mobile menu ── */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (mobileMenu && mobileMenu.classList.contains('is-open')) {
        mobileMenu.classList.remove('is-open');
        if (hamburger) {
          hamburger.classList.remove('is-open');
          hamburger.setAttribute('aria-expanded', 'false');
          hamburger.setAttribute('aria-label', 'Open menu');
          hamburger.focus();
        }
      }
    }
  });

})();
